import leadTableActions from './leadList';
import leadProfileActions from './leadData';

export default {
  ...leadTableActions,
  ...leadProfileActions
};
